module.exports = require('handlebars/runtime');


//////////////////
// WEBPACK FOOTER
// ./~/handlebars-template-loader/runtime/index.js
// module id = 7
// module chunks = 0